import {
  IdentityVerificationStatus,
  isDocumentVerifiedTier,
  needsIdentityVerification,
} from '../models/identity-verification.model';

export function shouldPromptIdentityVerification(
  status: IdentityVerificationStatus | null | undefined,
  layerEnabled: boolean,
): boolean {
  if (!layerEnabled) {
    return false;
  }
  if (isDocumentVerifiedTier(status?.tier)) {
    return false;
  }
  if (status?.inGracePeriod) {
    return false;
  }
  return needsIdentityVerification(status?.tier);
}

export function canExpandFamily(
  status: IdentityVerificationStatus | null | undefined,
  layerEnabled: boolean,
): boolean {
  if (!layerEnabled) {
    return true;
  }
  if (typeof status?.canPerformFamilyActions === 'boolean') {
    return status.canPerformFamilyActions;
  }
  if (isDocumentVerifiedTier(status?.tier)) {
    return true;
  }
  return Boolean(status?.inGracePeriod);
}
